import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-api-table',
    templateUrl: './api-table.component.html',
    styleUrls: ['./api-table.component.css']
})
export class ApiTableComponent implements OnInit  {

    @Input()
    public title;

    @Input()
    public header;

    @Input()
    public data;

    public data1;
    public header1;
    public title1;

    constructor() {
    }

    ngOnInit() {

        this.data1 = JSON.parse(JSON.stringify(this.data))
        this.header1 = JSON.parse(JSON.stringify(this.header))
        this.title1 = this.title+''
    }

}
